var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-3"},_vm._l((3),function(n){return _c('v-col',{key:n,attrs:{"cols":"12","sm":"4"}},[_c('v-card',{attrs:{"elevation":"2","rounded":"xl"}},[_c('v-skeleton-loader',{staticClass:"pa-2",attrs:{"type":"article"}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }